import { Setting } from '../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import { CancelSurveyModalViewType } from '../types/view/CancelSurveyModalViewType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export const useUpdateSubscriptionStatus = () => {
  /**
   * 定期購買を解約する
   *
   * @param setting
   * @param subscription
   * @param cancelSurveyModal
   * @param success
   * @param failed
   * @param completion
   */
  const cancelSubscription = (
    setting: Setting,
    subscription: SubscriptionApiType,
    cancelSurveyModal: CancelSurveyModalViewType,
    success: () => void,
    failed: () => void,
    completion: () => void
  ) => {
    const data: {
      subscriptionId: string;
      status: string;
      survey: {
        selected?: string;
        extraField?: string;
      };
    } = {
      subscriptionId: subscription.subscriptionContractId,
      status: 'cancelled',
      survey: {
        selected: cancelSurveyModal.reasons.find((reason) => reason.selected)?.text,
        extraField: cancelSurveyModal.extraField,
      },
    };

    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateSubscription`,
        { ...data },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success();
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  /**
   * 定期購買を一時停止する
   *
   * @param setting
   * @param subscription
   * @param pauseSurveyModal
   * @param success
   * @param failed
   * @param completion
   */
  const pauseSubscription = (
    setting: Setting,
    subscription: SubscriptionApiType,
    success: () => void,
    failed: () => void,
    completion: () => void
  ) => {
    const data: {
      subscriptionId: string;
      status: string;
    } = {
      subscriptionId: subscription.subscriptionContractId,
      status: 'paused',
    };

    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateSubscription`,
        { ...data },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success();
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  /**
   * 定期購買を再開する
   *
   * @param setting
   * @param subscription
   * @param success
   * @param failed
   * @param completion
   */
  const activeSubscription = (
    setting: Setting,
    subscription: SubscriptionApiType,
    success: () => void,
    failed: () => void,
    completion: () => void
  ) => {
    const data: {
      subscriptionId: string;
      status: string;
    } = {
      subscriptionId: subscription.subscriptionContractId,
      status: 'active',
    };

    axios
      .post(
        `${CUSTOMER_API_URL}?action=updateSubscription`,
        { ...data },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success();
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  return {
    cancelSubscription,
    pauseSubscription,
    activeSubscription,
  };
};
